import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import classNames from 'classnames';
import styles from './Modal.scss.js';
import BaseModal from '../BaseModal/BaseModal.js';
import CloseIcon from '../../IconsDeprecated/CloseIcon.js';
import Icon from '../../../Icons/Icons/Icon/Icon.js';

/**
 * @deprecated In favor of the new Modal of the BCL, see (https://nearpod-packages.gitlab-pages.nearpod.com/base-component-library/?path=/docs/library-modal--docs)
 */
const Modal = _ref => {
  let {
    isOpen = false,
    closeButton = false,
    onClose = () => {},
    children,
    backdrop = 'on',
    backdropBackground,
    isFullScreen = false,
    isScrollable = false,
    containerRef,
    verticalPositionOnContainer,
    disableFocusTrap = false,
    ariaLabel = '',
    ariaLabelledBy = ''
  } = _ref;
  return /*#__PURE__*/React.createElement(BaseModal, {
    isOpen: isOpen,
    backdrop: backdrop,
    backdropBackground: backdropBackground,
    onBackdropClick: onClose,
    isScrollable: isScrollable,
    containerRef: containerRef,
    verticalPositionOnContainer: verticalPositionOnContainer,
    disableFocusTrap: disableFocusTrap
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(styles.wrapper, {
      [styles['wrapper--fixed']]: !isScrollable && !containerRef,
      [styles.fullscreen]: isFullScreen,
      [styles['wrapper--scrollable']]: isScrollable
    }),
    role: "dialog",
    "aria-modal": "true"
  }, ariaLabel ? {
    'aria-label': ariaLabel
  } : {}, ariaLabelledBy ? {
    'aria-labelledby': ariaLabelledBy
  } : {}), closeButton && !isFullScreen && /*#__PURE__*/React.createElement("button", {
    className: styles['close-cross'],
    onClick: onClose,
    tabIndex: 0,
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(CloseIcon, null)), closeButton && isFullScreen && /*#__PURE__*/React.createElement("div", {
    className: styles['close-header']
  }, /*#__PURE__*/React.createElement("button", {
    className: styles['close-button'],
    onClick: onClose,
    tabIndex: -1,
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "system-ui-open-close-drawer-blue"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classNames({
      [styles.content]: true,
      [styles['no-header']]: isFullScreen && !closeButton
    })
  }, children)));
};
var Modal$1 = Modal;

export { Modal$1 as default };
//# sourceMappingURL=Modal.js.map
